import './articlelink.less'

import {Background, Component, Picture, action, classes} from '@codeurs/front'
import {ImageType, WysiwygType} from 'types/types'

import Link from 'views/layout/link'
import PressImage from 'assets/icons/press.svg'
import TagLink from 'views/layout/taglink'
import Title from 'views/layout/title'
import Wysiwyg from 'views/layout/wysiwyg'
import {format} from 'date-fns'
import m from 'mithril'
import {t} from 'store'

export type ArticleType = {
	url: string
	path: string
	date: Date
	intro_image: ImageType
	label: Array<string>
	description: WysiwygType
	title: string
	featured: Boolean
	publication: Publication
	tags: Array<string>
	key?: string
}
export type Publication = {
	description: string
	title: string
	url: string
}
export default class ArticleLink extends Component<
	ArticleType & {mod?: 'flat' | 'search'}
> {
	view() {
		const {
			mod,
			date,
			intro_image,
			label,
			description,
			title,
			featured = false,
			path,
			url = window.location.pathname + '/' + path,
			publication,
			tags
		} = this.attrs
		return m('.articlelink', {...classes({mod}, {mod: {featured}})}, [
			this.getTopView(url, featured, intro_image, label, publication, title),
			this.getBottomView(date, title, description, url, tags, intro_image)
		])
	}

	getTopView(
		url: string,
		featured: Boolean,
		intro_image: ImageType,
		label: Array<string>,
		publication: Publication,
		title: string
	) {
		return (
			intro_image &&
			!intro_image.empty &&
			m('a.articlelink-top', {...action(url), ariaLabel: title}, [
				featured && m('.articlelink-top-featured', t('articles.featured')),
				intro_image &&
					m(Picture, {
						fit: 'cover',
						class: 'articlelink-top-image',
						...intro_image
					}),
				label && this.getLabel(label, publication)
			])
		)
	}
	getBottomView(
		date: Date,
		title: string,
		description: string,
		url: string,
		tags: Array<string>,
		intro_image: ImageType
	) {
		const {mod} = this.attrs
		return m('.articlelink-bottom', {class: intro_image && 'mod-no-image'}, [
			m('.articlelink-bottom-date', this.getDate(date)),
			title &&
				m('a.articlelink-bottom-title',
					action(url),
					m('h2.articlelink-bottom-title-text', title)
				),
			m('a.articlelink-bottom-content',
				action(url),
				m(Wysiwyg, {html: description})
			),
			m(Link,
				{...action(url), ...classes({mod: 'blue'}, 'articlelink-bottom-link')},
				[
					m('.articlelink-bottom-link-text', t('articles.readmore')),
					m('.articlelink-bottom-link-arrow', '>')
				]
			),
			mod == 'search' &&
				tags[0] &&
				m('.articlelink-bottom-tagscontainer', [
					m('.articlelink-bottom-tagscontainer-copy', t('articles.tags') + ':'),
					m('.articlelink-bottom-tagscontainer-tags', this.getTags(tags))
				])
		])
	}
	getTags(tags: Array<string>) {
		if (tags) {
			const lastTag = tags.slice(-1)[0]
			return tags.map(tag =>
				m(TagLink, {
					mod: 'tag',
					text: tag
				})
			)
		}
		return
	}
	getLabel(label: Array<string>, publication: Publication) {
		if (label.length && label[0] == 'news') return
		return m('.articlelink-top-label', [
			this.getLabelImage(label, publication),
			m('.articlelink-top-label-text', this.getLabelText(label, publication))
		])
	}

	getLabelImage(label: Array<string>, publication: Publication) {
		if (!publication?.title) return
		const {url} = this.attrs
		return m('img.articlelink-top-label-img', {
			src: PressImage,
			alt: label
		})
	}
	getLabelText(label: Array<string>, publication: Publication) {
		if (label.length && label[0] == 'news') return t('articles.news')
		if (publication?.title) return t('articles.positionpaper')
		return
	}
	getDate(date: Date) {
		return format(date, 'D MMMM YYYY')
	}
}
